import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UsuarioGateway } from "src/app/domain/models/usuario/gateways/usuario.gateway";
import { UsuarioRequestModel } from "src/app/domain/models/usuario/usuario-request.model";
import { UsuarioUltConexionModel } from "src/app/domain/models/usuario/usuario-ult-conexion.model";
import { environments } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})
export class UsuarioAdapter extends UsuarioGateway {

    _back_url_base: string;    

    constructor(private http: HttpClient) {
        super();
        this._back_url_base = environments.BACK_URL_BASE;
    }

    ultimaConexion(usuario:UsuarioRequestModel): Observable<UsuarioUltConexionModel> {
        
        return this.http.put<UsuarioUltConexionModel>(
            `${this._back_url_base}api/usuario/ultima-conexion`,
            usuario          
        );
    }

}